package com.ustadmobile.door.util

enum class TransactionMode {
    READ_WRITE, READ_ONLY
}